import React, { Component } from 'react';
import { matchPath } from 'react-router';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as ProductTypesActions } from 'store/ducks/productsTypes';

import { Page, Form, Loading, Breadcrumbs } from 'components';

class Edit extends Component {
  state = {
    data: {
      external_id: '',
      name: '',
      score: '',
    },
    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Pontos', to: '/points' },
      { name: 'Tipo de Produtos', to: '/points/products-types' },
      { name: 'Editar Tipo do Produto', to: '' },
    ],
  };

  componentDidMount() {
    const { getProductTypeRequest } = this.props;
    getProductTypeRequest(this.handleGetID());
  }

  componentDidUpdate(oldProps) {
    const { productType } = this.props;

    if (oldProps.productType.loading && !productType.loading) {
      this.setState({
        data: {
          external_id: productType.data.attributes.external_id,
          name: productType.data.attributes.name,
          score: productType.data.attributes.score,
        },
      });
    }
  }

  handleGetID = () => {
    const { location } = this.props;

    const match = matchPath(location.pathname, { path: '/points/products-types/:id/edit' });
    const { id } = match.params;

    return id;
  };

  handleToggleScore = () => {
    const { data } = this.state;

    this.setState({ data: { ...data, score: !data.score } });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { data } = this.state;

    this.props.updateProductsTypeRequest(this.handleGetID(), { product_type: { score: data.score } });
  };

  render() {
    const { data, breadcrumbs } = this.state;
    const { update } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form className="page-form">
          <h3 className="form-title">Tipos de Produtos</h3>

          <Form.Field>
            <Form.Label>sigla</Form.Label>
            <Form.Input name="initials" placeholder="ZGAR" value={data.external_id} readOnly />
          </Form.Field>

          <Form.Field>
            <Form.Label>tipo de produto</Form.Label>
            <Form.Input name="product-type" placeholder="Garantia" value={data.name} readOnly />
          </Form.Field>

          <Form.Field className="checkbox-field">
            <Form.Label>Ativar tipo de produto</Form.Label>
            <Form.Checkbox checked={data.score} onChange={this.handleToggleScore} />
          </Form.Field>

          <div className="buttons">
            <Link to="/points/products-types" className="button-cancel">
              Cancelar
            </Link>

            <Form.Button className="button-save" onClick={this.handleSubmit} disabled={update.loading}>
              {update.loading ? <Loading type="btn" size="small" text="Salvando..." /> : 'Salvar'}
            </Form.Button>
          </div>
        </Form>
      </Page>
    );
  }
}

const mapState = state => ({
  productType: state.productsTypes.detail,
  update: state.productsTypes.update,
});

const mapActions = dispatch => bindActionCreators(ProductTypesActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Edit);
